/** @file Client setup snippets for one API token: .mcp.json, Codex config.toml, env lines (§10.4). */
import { clientSetup } from '@pose2d/api/clients/clientSetup';
import { tokenEnvName } from '@pose2d/api/clients/tokenEnvName';

/** One snippet; `id` keys its translated title. */
export interface ClientConfig {
  id: 'claudeCode' | 'codex' | 'env';
  text: string;
}

/** `origin` is the page origin (the MCP server is `<origin>/mcp`, '' = production); `secret` fills the env lines (or a placeholder). */
export function clientConfigs(origin: string, name: string, secret: string): ClientConfig[] {
  const env = tokenEnvName(name);
  const files = clientSetup({ ...(origin === '' ? {} : { url: origin }), claudeEnv: env, codexEnv: env });
  const text = (path: string): string => (files.find((file) => file.path === path)?.text ?? '').trimEnd();
  return [
    { id: 'claudeCode', text: text('claude-code.mcp.json') },
    { id: 'codex', text: text('codex.config.toml') },
    { id: 'env', text: [`export ${env}='${secret}'`, `$env:${env} = '${secret}'`].join('\n') },
  ];
}
